import {Injectable} from '@angular/core';
import {SessionProvider} from './model/SessionProvider';
import {StreamSessionProvider} from './stream/StreamSessionProvider';

@Injectable({
  providedIn: 'root',
})
export class SessionProviderFactory {
  constructor(private streamProvider: StreamSessionProvider) {}

  getProvider(): SessionProvider {
    return this.streamProvider;
  }
}
